import { render } from "./BannerModal.vue?vue&type=template&id=7f013ea7&scoped=true"
import script from "./BannerModal.vue?vue&type=script&lang=js"
export * from "./BannerModal.vue?vue&type=script&lang=js"

import "./BannerModal.vue?vue&type=style&index=0&id=7f013ea7&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f013ea7"]])

export default __exports__